import api from '../base';
import { XLSX_MIME_TYPE } from '../../services/excel/constants';

const COMMISSIONS_BASE_PATH = 'management/pricing/commissions';

export const COMMISSIONS_IMPORT_PATH = `${COMMISSIONS_BASE_PATH}/import`;
export const COMMISSIONS_DEFAULTS_IMPORT_PATH = `${COMMISSIONS_BASE_PATH}/defaults/import`;

const COMMISSIONS_EXPORT_PATH = `${COMMISSIONS_BASE_PATH}/export`;
const COMMISSIONS_DEFAULTS_EXPORT_PATH = `${COMMISSIONS_BASE_PATH}/defaults/export`;

export async function exportCommissions(): Promise<Blob> {
  const response = await api.get<Blob>(COMMISSIONS_EXPORT_PATH, {
    responseType: 'blob',
  });

  return response.data;
}

api.mock
  .onGet(COMMISSIONS_EXPORT_PATH)
  .reply(200, new Blob(), {
    'Content-Type': XLSX_MIME_TYPE,
  });

export async function exportDefaultCommissions(): Promise<Blob> {
  const response = await api.get<Blob>(COMMISSIONS_DEFAULTS_EXPORT_PATH, {
    responseType: 'blob',
  });

  return response.data;
}

api.mock
  .onGet(COMMISSIONS_DEFAULTS_EXPORT_PATH)
  .reply(200, new Blob(), {
    'Content-Type': XLSX_MIME_TYPE,
  });
